import EmptyDataState from './component'

export default EmptyDataState